import React from 'react';
import { ButtonBase, Paper, Typography, Box } from '@mui/material';
import Favorite from '@mui/icons-material/Favorite';
import { ICON_COLOR } from '../colorPalette';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

function NearbyHeartListItem({heart, onClick, index}) {

    return (
        <ButtonBase onClick={onClick} sx={{width: '100%', marginTop: '5px'}}>
            <Paper style={{width: '100%', textAlign: 'left' }}>
                <Box sx={{display: 'flex', width:'100%', flexDirection: 'row', padding: '5px', justifyContent: 'space-between'}}>
                    <Favorite sx={{fontSize: '40px', fill: ICON_COLOR}} />
                    <Box sx={{display: 'flex', flexDirection: 'column', flexGrow: 1, textAlign: 'left', justifyContent: 'center', marginLeft: '15px'}}> 
                        <Typography variant={'body2'} fontSize={'12px'} fontWeight={'500'}>MAC:</Typography>
                        <Typography variant={'body2'} fontSize={'12px'}>{heart.id}</Typography>
                    </Box>
                    <Box sx={{display: 'flex', flexDirection: 'column', justifyContent: 'center', marginRight: '15px'}}>
                        <ChevronRightIcon sx={{fill: ICON_COLOR}} />
                    </Box>
                </Box>
            </Paper>
        </ButtonBase>
    )
}

export default NearbyHeartListItem;